import styled from 'styled-components';

const Groups = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export default Groups;
